import { string, table } from "@rocicorp/zero";

export const user = table("users")
	.columns({
		id: string(),
		firstName: string().from("first_name"),
		lastName: string().from("last_name"),
		initials: string(),
		email: string(),
	})
	.primaryKey("id");
// The table's generated "name" column stays out on purpose: zero-cache's publication does not
// set publish_generated_columns, so the replication stream omits generated columns and the
// replica would drift from its initial sync. Compose the display name from firstName/lastName.
